import { api } from '../../shared/api/client';

export interface PartnershipInput {
  fullName: string;
  clinic: string;
  city: string;
  phone: string;
  email: string;
  comment: string;
}

export interface PartnershipRequest extends PartnershipInput {
  id: string;
  createdAt: string;
  status: 'new' | 'closed';
  closedAt: string | null;
  createdUserId: string | null;
}

/** Заявка «Сотрудничество» из письма со снимками (без авторизации). */
export async function submitPartnership(body: PartnershipInput): Promise<void> {
  await api.post('/v1/public/partnership', body);
}

export async function listPartnershipRequests(
  status: 'new' | 'closed' = 'new',
  offset = 0,
): Promise<{
  items: PartnershipRequest[];
  total: number;
}> {
  const { data } = await api.get<{ items: PartnershipRequest[]; total: number }>(
    '/v1/admin/partnership-requests',
    { params: { status, limit: 50, offset } },
  );
  return data;
}

export async function getPartnershipRequest(id: string): Promise<PartnershipRequest> {
  const { data } = await api.get<PartnershipRequest>(`/v1/admin/partnership-requests/${id}`);
  return data;
}

export async function closePartnershipRequest(id: string): Promise<PartnershipRequest> {
  const { data } = await api.post<PartnershipRequest>(`/v1/admin/partnership-requests/${id}/close`);
  return data;
}
